import { render, staticRenderFns } from "./DoKoSignup.vue?vue&type=template&id=4bfdb6f7&scoped=true&"
import script from "./DoKoSignup.vue?vue&type=script&lang=ts&"
export * from "./DoKoSignup.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoSignup.vue?vue&type=style&index=0&id=4bfdb6f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfdb6f7",
  null
  
)

export default component.exports